import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { salesService } from '../../services/salesService';

const InvoicePrint = () => {
    const { id } = useParams();
    const [invoice, setInvoice] = useState(null);

    useEffect(() => {
        const fetchInvoice = async () => {
            try {
                const response = await salesService.getSalesInvoice(id);
                if (response.success) {
                    setInvoice(response.data);
                    // Automatically trigger print after loading
                    setTimeout(() => {
                        window.print();
                    }, 1000);
                }
            } catch (error) {
                console.error("Failed to load invoice", error);
            }
        };
        fetchInvoice();
    }, [id]);

    if (!invoice) return <div>Loading Invoice...</div>;

    const { company, receiver, items, taxDetails } = invoice;
    const tax = taxDetails?.[0] || {};

    return (
        <div className="invoice-container" style={{ padding: '20px', fontFamily: 'Arial, sans-serif', maxWidth: '1000px', margin: '0 auto' }}>
            {/* Header */}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <div style={{ width: '60%' }}>
                    {company.logoUrl && <img src={company.logoUrl} alt="Logo" style={{ maxHeight: '80px', marginBottom: '10px' }} />}
                    <h2 style={{ margin: '0', color: '#1a365d' }}>{company.companyName}</h2>
                    <p style={{ margin: '5px 0', fontSize: '14px', whiteSpace: 'pre-line' }}>
                        {company.address}
                    </p>
                    <p style={{ margin: '5px 0', fontSize: '14px' }}>
                        <strong>GSTIN:</strong> {company.gstn} | <strong>Email:</strong> {company.email}
                    </p>
                </div>
                <div style={{ textAlign: 'right' }}>
                    <h1 style={{ fontSize: '24px', color: '#2c5282', textTransform: 'uppercase' }}>Tax Invoice</h1>
                    <table style={{ float: 'right', borderCollapse: 'collapse', fontSize: '14px' }}>
                        <tbody>
                            <tr>
                                <td style={{ padding: '5px', fontWeight: 'bold' }}>Invoice No:</td>
                                <td style={{ padding: '5px' }}>{invoice.invoiceNumber}</td>
                            </tr>
                            <tr>
                                <td style={{ padding: '5px', fontWeight: 'bold' }}>Date:</td>
                                <td style={{ padding: '5px' }}>{new Date(invoice.invoiceDate).toLocaleDateString()}</td>
                            </tr>
                            <tr>
                                <td style={{ padding: '5px', fontWeight: 'bold' }}>PO / Contract Ref:</td>
                                <td style={{ padding: '5px' }}>{invoice.poNumber || '-'}</td>
                            </tr>
                            <tr>
                                <td style={{ padding: '5px', fontWeight: 'bold' }}>Place of Supply:</td>
                                <td style={{ padding: '5px' }}>{receiver.district || receiver.customerAddress || 'Maharashtra'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Billed To */}
            <div style={{ border: '1px solid #000', padding: '10px', marginBottom: '20px', display: 'flex' }}>
                <div style={{ flex: 1 }}>
                    <h3 style={{ marginTop: 0, fontSize: '16px', borderBottom: '1px solid #ddd', paddingBottom: '5px' }}>Billed To</h3>
                    <p style={{ fontWeight: 'bold', margin: '5px 0' }}>{receiver.customerName}</p>
                    <p style={{ margin: '5px 0', fontSize: '14px', whiteSpace: 'pre-line' }}>{receiver.customerAddress}</p>
                    {receiver.gstn && <p style={{ margin: '5px 0', fontSize: '14px' }}>GSTIN: {receiver.gstn}</p>}
                    <p style={{ margin: '5px 0', fontSize: '14px' }}>Mobile: {receiver.customerMobile}</p>
                </div>
            </div>

            {/* Items Table */}
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #000', marginBottom: '20px', fontSize: '12px' }}>
                <thead>
                    <tr style={{ backgroundColor: '#f0f0f0' }}>
                        <th style={{ border: '1px solid #000', padding: '8px' }}>Sr.</th>
                        <th style={{ border: '1px solid #000', padding: '8px', textAlign: 'left' }}>Description of Goods/Services</th>
                        <th style={{ border: '1px solid #000', padding: '8px' }}>HSN/SAC</th>
                        <th style={{ border: '1px solid #000', padding: '8px' }}>Qty</th>
                        <th style={{ border: '1px solid #000', padding: '8px' }}>Rate</th>
                        <th style={{ border: '1px solid #000', padding: '8px' }}>Taxable Amt</th>
                        <th style={{ border: '1px solid #000', padding: '8px' }}>CGST/SGST</th>
                        <th style={{ border: '1px solid #000', padding: '8px' }}>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={index}>
                            <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'center' }}>{index + 1}</td>
                            <td style={{ border: '1px solid #000', padding: '8px' }}>
                                <strong>{item.description || (item.natureKey ? item.natureKey.toUpperCase() : item.item?.itemName)}</strong>
                            </td>
                            <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'center' }}>{item.item?.hsnCode || '-'}</td>
                            <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'center' }}>{item.quantity}</td>
                            <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'right' }}>{parseFloat(item.rate).toFixed(2)}</td>
                            <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'right' }}>{parseFloat(item.amountBeforeTax).toFixed(2)}</td>
                            <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'right' }}>
                                {((item.taxAmount || 0)).toFixed(2)}
                            </td>
                            <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'right' }}>{parseFloat(item.totalAmount).toFixed(2)}</td>
                        </tr>
                    ))}
                    {/* Empty rows filler if needed, skipping for now */}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={5} style={{ border: '1px solid #000', padding: '8px', textAlign: 'right', fontWeight: 'bold' }}>Total</td>
                        <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'right', fontWeight: 'bold' }}>{parseFloat(invoice.totalBeforeTax).toFixed(2)}</td>
                        <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'right', fontWeight: 'bold' }}>{parseFloat(invoice.totalTax).toFixed(2)}</td>
                        <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'right', fontWeight: 'bold' }}>{parseFloat(invoice.totalAfterTax).toFixed(2)}</td>
                    </tr>
                </tfoot>
            </table>

            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <div style={{ width: '60%' }}>
                    <p style={{ margin: '5px 0' }}><strong>Amount in Words:</strong> {invoice.amountInWords}</p>
                    <div style={{ border: '1px solid #000', padding: '10px', marginTop: '10px', fontSize: '12px' }}>
                        <strong>Bank Details:</strong><br />
                        Bank Name: {company.bankName}<br />
                        A/c No: {company.accountNumber}<br />
                        IFSC: {company.ifscCode}<br />
                        Branch: {company.branchName}
                    </div>
                </div>
                <div style={{ width: '35%', textAlign: 'center', marginTop: '40px' }}>
                    <p style={{ fontWeight: 'bold' }}>For {company.companyName}</p>
                    <br /><br /><br />
                    <p>Authorized Signatory</p>
                </div>
            </div>

            {/* Contract Amount Note */}
            {invoice.contractAmount > 0 && (
                <div style={{ marginTop: '20px', borderTop: '1px dashed #000', paddingTop: '10px' }}>
                    <strong>Project Contract Value:</strong> ₹{parseFloat(invoice.contractAmount).toFixed(2)}
                </div>
            )}

            <div style={{ textAlign: 'center', marginTop: '30px', fontSize: '10px', color: '#666' }}>
                This is a computer generated invoice.
            </div>
        </div>
    );
};

export default InvoicePrint;
